import RoundPresentationsReadOnlyList from "./RoundPresentationsReadOnlyList";
import RoundTabPanel from "./RoundTabPanel";
import { ScheduleItem } from "../../interfaces/ISchedules";
import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { useState } from "react";

interface SchedulePositionRoundsTabsReadOnlyProps {
  roundItems: ScheduleItem[];
  competitionId: string;
}

export default function SchedulePositionRoundsTabsReadOnly({
  roundItems,
  competitionId,
}: SchedulePositionRoundsTabsReadOnlyProps) {
  const [selectedTab, setSelectedTab] = useState(0);

  const renderTitleBlock = (item: ScheduleItem) => (
    <Box sx={{ px: 2, pt: 2 }}>
      <Typography variant="h6" fontWeight={600} gutterBottom component="div">
        {item.title ?? ""}
      </Typography>
      {item.subtitle ? (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }} component="div">
          {item.subtitle}
        </Typography>
      ) : null}
    </Box>
  );

  const renderList = (item: ScheduleItem, index: number) => (
    <RoundPresentationsReadOnlyList
      competitionId={competitionId}
      categoryId={item.competitionCategoryId!}
      roundId={item.competitionRoundId!}
      enabled={roundItems.length === 1 ? true : selectedTab === index}
      tabIndex={index}
    />
  );

  if (roundItems.length === 1) {
    const item = roundItems[0];
    return (
      <>
        {/* Kotwica jak przy wielu zakładkach (wysokość 0) — spójny offset scrolla do DANCING */}
        <Box
          id="schedule-position-tabs-anchor"
          sx={{ position: "sticky", top: 0, height: 0, overflow: "hidden", width: "100%" }}
          aria-hidden
        />
        <RoundTabPanel value={0} index={0}>
        {renderTitleBlock(item)}
        <Divider />
        {renderList(item, 0)}
      </RoundTabPanel>
      </>
    );
  }

  return (
    <>
      <Box
        id="schedule-position-tabs-anchor"
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          bgcolor: "background.paper",
          boxShadow: (theme) =>
            theme.palette.mode === "dark" ? "0 2px 4px rgba(0,0,0,0.35)" : "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <Grid container spacing={0.5} sx={{ px: 0.5, py: 0.5 }}>
          {roundItems.map((item, index) => (
            <Grid item xs={4} key={item.id}>
              <Button
                fullWidth
                variant={selectedTab === index ? "contained" : "outlined"}
                onClick={() => setSelectedTab(index)}
                id={`round-tab-${index}`}
                aria-controls={`round-tabpanel-${index}`}
                sx={{
                  textTransform: "none",
                  py: 1.5,
                  px: 1,
                  fontSize: { xs: "0.75rem", sm: "0.875rem" },
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  textAlign: "center",
                  minHeight: { xs: "48px", sm: "56px" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "&:hover": {
                    bgcolor: selectedTab === index ? undefined : "action.hover",
                  },
                }}
              >
                {item.subtitle || item.title}
              </Button>
            </Grid>
          ))}
        </Grid>
        <Divider />
      </Box>
      <Box>
        {roundItems.map((item, index) => (
          <RoundTabPanel key={item.id} value={selectedTab} index={index}>
            {renderTitleBlock(item)}
            <Divider />
            {renderList(item, index)}
          </RoundTabPanel>
        ))}
      </Box>
    </>
  );
}
